/** Convert any YYYY-MM-DD (or YYYY-MM-DD HH:MM) string to DD/MM/YYYY. Returns '—' for null/empty. */
export function fmtDate(d) {
  if (!d) return '—';
  const s = String(d).split('T')[0].split(' ')[0];
  const parts = s.split('-');
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return d;
}
